(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-lookbook]');

    sections.forEach((section) => {
      const hotspots = section.querySelectorAll('[data-lookbook-hotspot]');

      const closeAll = () => {
        hotspots.forEach((hotspot) => {
          const overlay = section.querySelector(`#${hotspot.getAttribute('aria-controls')}`);
          if (!overlay) return;

          overlay.hidden = true;
          hotspot.setAttribute('aria-expanded', 'false');
        });
      };

      hotspots.forEach((hotspot) => {
        const overlay = section.querySelector(`#${hotspot.getAttribute('aria-controls')}`);
        if (!overlay) return;

        hotspot.addEventListener('click', (event) => {
          event.stopPropagation();
          const isOpen = hotspot.getAttribute('aria-expanded') === 'true';

          closeAll();

          if (!isOpen) {
            overlay.hidden = false;
            hotspot.setAttribute('aria-expanded', 'true');
          }
        });

        overlay.querySelectorAll('[data-lookbook-close]').forEach((closeButton) => {
          closeButton.addEventListener('click', (event) => {
            event.stopPropagation();
            closeAll();
            hotspot.focus();
          });
        });
      });

      section.addEventListener('click', (event) => {
        if (!event.target.closest('[data-lookbook-overlay]') && !event.target.closest('[data-lookbook-hotspot]')) {
          closeAll();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeAll();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
